import { render } from "./viewLotComponent.vue?vue&type=template&id=2339e67f"
import script from "./viewLotComponent.vue?vue&type=script&lang=js"
export * from "./viewLotComponent.vue?vue&type=script&lang=js"

import "./viewLotComponent.vue?vue&type=style&index=0&id=2339e67f&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__